export default __webpack_public_path__ + "static/media/sunny_night.ff2360e7.svg";